import React, { useMemo, useCallback } from 'react';
import { ReactSlideEvent } from '../types';
import Mark from './Mark';
import { useMarksStyles } from './styles';

export interface MarksProps {
	vertical: boolean;
	handlerSize: number;
	marks: any;
	upperBound: number;
	lowerBound: number;
	range: number;
	onChange?: (point: number) => void;
}

export default function Marks({
	vertical,
	handlerSize,
	marks,
	upperBound,
	lowerBound,
	range,
	onChange,
}: MarksProps) {
	const onClick = useCallback((event: ReactSlideEvent) => {
		event.stopPropagation();
		event.nativeEvent.stopImmediatePropagation();
	}, []);
	const points = useMemo(() => Object.keys(marks).map(parseFloat).sort((a, b) => a - b), [marks]);
	const styles = useMarksStyles([vertical, handlerSize]);

	return (
		<div
			className={styles.marks}
			onClick={onClick}
		>
			{points.map(point => (
				<Mark
					key={point}
					className={styles.mark}
					vertical={vertical}
					mark={marks[point]}
					point={point}
					lowerBound={lowerBound}
					range={range}
					active={point <= upperBound && point >= lowerBound}
					onChange={onChange}
				/>
			))}
		</div>
	);
}
